import React from "react";
import { DataTable } from "primereact/datatable";

export const OrderDeliveryList = (props) => (
  
  <DataTable
    selectionMode="single"
    onFilter={props.onFilter}
    onSort={props.onSort}
    onPage={props.onPage}
    value={props.records}
    lazy={true}
    totalRecords={props.totalRecords}
    sortOrder={props.order}
    sortField={props.sortField}
    paginator={true}
    first={props.first}
    rows={props.rows}
    scrollHeight={"calc(100vh - 460px)"}
    scrollable={true}
    emptyMessage="Não foram encontrados registros"
    onRowClick={props.onRowClick}
    rowsPerPageOptions={[5, 10, 20, 50]}
  >
    {props.columns}
  </DataTable>
);
